import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { Input, Row, Col, Button, Avatar, Empty, Spin } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { USER, BASE } from 'api';
import request from '../../../utils/request';
import Modal from '../../../components/Modal/index';
import { ReactComponent as OpenGrayLock } from '../../../images/open_gray_lock.svg';
import { ReactComponent as GrayTrash } from '../../../images/gray_trash.svg';
import { ReactComponent as BoxClose } from '../../../images/box-close.svg';
const Inner = styled.div`
  &&& {
    padding: 40px;
    .ant-input-group-addon {
      background: none;
      border: none;
      padding: 0;
      color: #9f9f9f;
      margin-bottom: 8px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .ant-input-wrapper {
      display: flex;
      flex-direction: column;
    }
    .ant-input {
      border-radius: 6px !important;
    }
  }
`;

function ModalInfo({
  visible,
  setVisible,
  data,
  setUser,
  updateData,
  deleteData,
  getUsers,
  getTransactions,
}) {
  const afterClose = () => {
    setUser(null);
  };
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [count, setCount] = useState(2);
  const [loading, setLoading] = useState(false);

  const getLogs = async (data) => {
    setLoading(true);
    const response = await request(`${USER}/${data.id}/box_logs`);
    setLogs(response.objects);
    setLoading(false);
  };

  useEffect(() => {
    getLogs(data);
  }, [data]);

  const handleChangeData = (e, key, value) => {
    if (e.target.value !== value) {
      updateData(
        {
          [key]: e.target.value,
          id: data.id,
        },
        {
          sync: false,
          getSyncData: {
            fetchFunc: getTransactions ? getTransactions : getUsers,
            params: {
              role: getTransactions ? null : 'manager',
            },
          },
        },
      );
    }
  };

  const blockUser = (data) => {
    if (data) {
      updateData({
        active: false,
      });
    } else {
      updateData({
        active: true,
      });
    }
  };

  const deleteUser = (id) => {
    deleteData({
      id,
    });
  };

  return (
    <>
      <Modal
        afterClose={afterClose}
        visible={visible}
        width={727}
        setVisible={setVisible}
      >
        <Inner>
          <Row type="flex" className="w-full">
            <Col className="flex items-center" span={6}>
              {data.avatar ? (
                <Avatar
                  src={`${BASE}${data.avatar}`}
                  className="flex items-center justify-center w-100 h-100"
                />
              ) : (
                <Avatar className="flex items-center justify-center w-100 h-100">
                  {data.first_name[0]}
                </Avatar>
              )}
            </Col>
            <Col span={18}>
              <Row gutter={[16, 16]} type="flex" className="w-full">
                <Col span={12}>
                  <Input
                    defaultValue={data.last_name}
                    className="rounded-xs"
                    addonBefore={t('surname')}
                    onBlur={(e) => {
                      handleChangeData(e, 'last_name', data.last_name);
                    }}
                  />
                </Col>
                <Col span={12}>
                  <Input
                    defaultValue={data.first_name}
                    className="rounded-xs"
                    addonBefore={t('name')}
                    onBlur={(e) => {
                      handleChangeData(e, 'first_name', data.first_name);
                    }}
                  />
                </Col>
                <Col span={12}>
                  <Input
                    defaultValue={data.phone}
                    className="rounded-xs"
                    addonBefore={t('numPhone')}
                    onBlur={(e) => {
                      handleChangeData(e, 'phone', data.phone);
                    }}
                  />
                </Col>
                <Col span={12}>
                  <Input
                    defaultValue={data.email}
                    className="rounded-xs"
                    addonBefore={t('email')}
                    onBlur={(e) => {
                      handleChangeData(e, 'email', data.email);
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Inner>
        <Row className="mb-20" type="flex" align="middle">
          <Col span={8}>
            <div className="w-full h-1 bg-darkGray"></div>
          </Col>
          <Col className="pl-10" span={8}>
            <div className="text-18 text-black font-semibold flex cursor-pointer justify-center items-center">
              {t('actionHistory')}
            </div>
          </Col>
          <Col span={8}>
            <div className="w-full h-1 bg-darkGray"></div>
          </Col>
        </Row>
        <div className="text-center pl-40 pr-60">
          <Spin spinning={loading}>
            {logs ? (
              logs.length !== 0 ? (
                map(logs.slice(0, count), (log) => {
                  return (
                    <div className="operation">
                      <Row
                        justify="space-between"
                        className="border-b-1 border-solid border-lightGray pt-20 pb-20"
                      >
                        <Col span={6}>
                          <div className="flex">
                            <div className="border-r-1 pr-5 border-gray">
                              {moment(log.datetime).format('DD MMMM')}
                            </div>
                            <div className="ml-5 text-graytext">
                              {' '}
                              {moment(log.datetime).format('HH:MM')}
                            </div>
                          </div>
                        </Col>
                        <Col span={6}>
                          <div className="flex items-center">
                            {log.type === 'open' ? (
                              <>
                                <OpenGrayLock className="pr-7 w-23" />{' '}
                                {t('boxOpen')}
                              </>
                            ) : (
                              <>
                                <BoxClose className="mr-10" /> {t('boxClose')}
                              </>
                            )}
                          </div>
                        </Col>
                        <Col span={5}>{log.box.section.warehouse.name}</Col>
                        <Col span={7}>
                          <div className="flex justify-end">{log.box.name}</div>
                        </Col>
                      </Row>
                    </div>
                  );
                })
              ) : (
                <Empty />
              )
            ) : null}
          </Spin>
          {logs ? (
            logs.length > 2 && count !== logs.length ? (
              <div className="flex items-center justify-center">
                <Button
                  type="link"
                  onClick={() => {
                    setCount(logs.length);
                  }}
                  className="text-black hover:text-black hover:border-black h-auto p-0 m-0 border-t-0 border-r-0 border-l-0 rounded-none border-b-1 border-dotted border-black"
                >
                  <span className="border-b-1 border-dotted">
                    {t('showMore')}
                  </span>
                </Button>
              </div>
            ) : null
          ) : null}
        </div>
        <div className="pl-60 pr-60 flex items-center justify-center pb-40 pt-30">
          {data.active ? (
            <Button
              onClick={() => {
                blockUser(data.active);
              }}
              className="w-317 font-bold bg-pink border-none text-red rounded-lg flex items-center justify-center hover:bg-pink hover:text-red"
            >
              {t('blockUser')}
            </Button>
          ) : (
            <Button
              onClick={() => {
                blockUser(data.active);
              }}
              className="w-317 font-bold bg-ghostGreen border-none text-green rounded-lg flex items-center justify-center hover:bg-ghostGreen hover:text-green"
            >
              {t('unBlockUser')}
            </Button>
          )}
          <Button
            type="link"
            className="w-317 text-graytext rounded-lg flex items-center justify-center"
            onClick={() => {
              deleteUser(data.id);
            }}
          >
            <GrayTrash className="mr-10" />
            {t('deleteUser')}
          </Button>
        </div>
      </Modal>
    </>
  );
}

ModalInfo.propTypes = {};

export default ModalInfo;
